// extracted by mini-css-extract-plugin
export default {"image":"Image_image__tB92i","fullWidth":"Image_fullWidth__bbqOu"};